import { render, staticRenderFns } from "./OneTimeSettlement.vue?vue&type=template&id=5dd50f9c&scoped=true&"
import script from "./OneTimeSettlement.vue?vue&type=script&lang=js&"
export * from "./OneTimeSettlement.vue?vue&type=script&lang=js&"
import style0 from "./OneTimeSettlement.vue?vue&type=style&index=0&id=5dd50f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd50f9c",
  null
  
)

export default component.exports